export const minimumPasswordLength = 8;
export const passwordRequirementLabel = '8+ characters and a special character';
export const passwordRequirementMessage = `Password must be ${passwordRequirementLabel}.`;

const specialCharacterPattern = /[^A-Za-z0-9]/;

export function passwordMeetsCredentialPolicy(password: string): boolean {
  return password.length >= minimumPasswordLength && specialCharacterPattern.test(password);
}
